import { render, staticRenderFns } from "./Back2Top.vue?vue&type=template&id=70b8bf2b&"
import script from "./Back2Top.vue?vue&type=script&lang=js&"
export * from "./Back2Top.vue?vue&type=script&lang=js&"
import style0 from "./Back2Top.vue?vue&type=style&index=0&id=70b8bf2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports